function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useState, useCallback } from 'react';
import mse from "@adobe/magento-storefront-events-sdk";
import { STOREFRONT_PRODUCT_SEARCH_QUERY, STOREFRONT_ATTRIBUTE_METADATA_QUERY, STOREFRONT_CATEGORIES_QUERY, STOREFRONT_PRODUCT_SKUS_QUERY } from "./STOREFRONT_LIVE_SEARCH.gql";
import debounce from "../../util/debounce";
import { sendError } from '@magento/venia-ui/lib/util/noibu_helpers';
export var DEFAULT_SEARCH_UNIT_ID = "livesearch-adapter";
export var DEFAULT_CUSTOMER_GROUP = "0";
export var DEFAULT_CONTEXT = {
  customerGroup: DEFAULT_CUSTOMER_GROUP,
  userViewHistory: []
};

/*
let Be = "livesearch-popover", Ye = "livesearch popover-container", Ge = "livesearch product-result",
    He = "livesearch products-container", We = "livesearch product-name", Ke = "livesearch product-price",
    Ve = "livesearch suggestion", qe = "livesearch suggestions-container", Ze = "livesearch suggestions-header",
    Qe = "livesearch view-all-footer";
 */
//autocomplete -> "livesearch-popover",
//search -> "livesearch-adapter"

export var DEFAULT_PRODUCT_SEARCH_VARIABLES = {
  phrase: "",
  current_page: 1,
  page_size: 6,
  filter: [],
  sort: [],
  context: DEFAULT_CONTEXT
};
export var mapProductToAnalyticTemplate = response => {
  var _response$items;
  return response === null || response === void 0 || (_response$items = response.items) === null || _response$items === void 0 ? void 0 : _response$items.map((_ref, index) => {
    var _product$image, _product$price_range;
    var {
      product,
      productView
    } = _ref;
    return {
      name: product.name,
      sku: product.sku,
      url: productView.urlKey,
      imageUrl: (_product$image = product.image) === null || _product$image === void 0 ? void 0 : _product$image.url,
      price: ((_product$price_range = product.price_range) === null || _product$price_range === void 0 || (_product$price_range = _product$price_range.maximum_price) === null || _product$price_range === void 0 || (_product$price_range = _product$price_range.final_price) === null || _product$price_range === void 0 ? void 0 : _product$price_range.value) || 0,
      rank: index
    };
  });
};
var mapProductAttributesToKeyValuePairs = attributes => {
  if (!attributes || !attributes.length) return {};
  var productViewAttributes = {};
  attributes.forEach(attr => {
    productViewAttributes[attr.name] = attr.value;
  });
  return productViewAttributes;
};
export var mapProductToTemplate = function () {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return items === null || items === void 0 ? void 0 : items.map(item => {
    var _product$price_range2, _product$price_range3, _product$image2;
    var {
      product = {},
      productView = {}
    } = item;
    var attributes = mapProductAttributesToKeyValuePairs(productView.attributes);
    var regularPrice = ((_product$price_range2 = product.price_range) === null || _product$price_range2 === void 0 || (_product$price_range2 = _product$price_range2.maximum_price) === null || _product$price_range2 === void 0 || (_product$price_range2 = _product$price_range2.regular_price) === null || _product$price_range2 === void 0 ? void 0 : _product$price_range2.value) || 0;
    var finalPrice = ((_product$price_range3 = product.price_range) === null || _product$price_range3 === void 0 || (_product$price_range3 = _product$price_range3.maximum_price) === null || _product$price_range3 === void 0 || (_product$price_range3 = _product$price_range3.final_price) === null || _product$price_range3 === void 0 ? void 0 : _product$price_range3.value) || 0;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, product), productView), attributes), {}, {
      currency: 'CAD',
      shortDesc: productView.shortDescription,
      url_key: productView.urlKey,
      url_suffix: '.html',
      image: (_product$image2 = product.image) === null || _product$image2 === void 0 ? void 0 : _product$image2.url,
      price: regularPrice,
      basePrice: regularPrice,
      startPrice: regularPrice,
      salePrice: finalPrice
    });
  });
};
export var mapProductViewToTemplate = function () {
  var productViews = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return productViews === null || productViews === void 0 ? void 0 : productViews.map(item => {
    var _item$priceRange, _item$priceRange2, _priceObj$regular, _priceObj$regular2, _priceObj$final, _item$images, _item$images$;
    var attributes = mapProductAttributesToKeyValuePairs(item.attributes);
    var priceObj = item.price || ((_item$priceRange = item.priceRange) === null || _item$priceRange === void 0 ? void 0 : _item$priceRange.maximum) || ((_item$priceRange2 = item.priceRange) === null || _item$priceRange2 === void 0 ? void 0 : _item$priceRange2.minimum);
    var currency = (priceObj === null || priceObj === void 0 || (_priceObj$regular = priceObj.regular) === null || _priceObj$regular === void 0 || (_priceObj$regular = _priceObj$regular.amount) === null || _priceObj$regular === void 0 ? void 0 : _priceObj$regular.currency) || 'CAD';
    var regularPrice = (priceObj === null || priceObj === void 0 || (_priceObj$regular2 = priceObj.regular) === null || _priceObj$regular2 === void 0 || (_priceObj$regular2 = _priceObj$regular2.amount) === null || _priceObj$regular2 === void 0 ? void 0 : _priceObj$regular2.value) || 0;
    var finalPrice = (priceObj === null || priceObj === void 0 || (_priceObj$final = priceObj.final) === null || _priceObj$final === void 0 || (_priceObj$final = _priceObj$final.amount) === null || _priceObj$final === void 0 ? void 0 : _priceObj$final.value) || 0;
    return _objectSpread(_objectSpread(_objectSpread({}, item), attributes), {}, {
      currency,
      id: item.externalId,
      shortDesc: item.shortDescription,
      url_key: item.urlKey,
      url_suffix: '.html',
      image: ((_item$images = item.images) === null || _item$images === void 0 ? void 0 : _item$images.length) && ((_item$images$ = item.images[0]) === null || _item$images$ === void 0 ? void 0 : _item$images$.url),
      price: regularPrice,
      basePrice: regularPrice,
      startPrice: regularPrice,
      salePrice: finalPrice
    });
  });
};
var useStorefrontLiveSearch = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var {
    includeCategories,
    includeSuggestions,
    PRODUCT_SKUS_QUERY = STOREFRONT_PRODUCT_SKUS_QUERY,
    PRODUCT_SEARCH_QUERY = STOREFRONT_PRODUCT_SEARCH_QUERY,
    ATTRIBUTE_METADATA_QUERY = STOREFRONT_ATTRIBUTE_METADATA_QUERY,
    CATEGORIES_METADATA_QUERY = STOREFRONT_CATEGORIES_QUERY,
    searchUnitId = DEFAULT_SEARCH_UNIT_ID,
    debounceTimeout = 1000
  } = props;
  var [productSearchData, setProductSearchData] = useState(null);
  var [productSearchLoading, setProductSearchLoading] = useState(false);
  var [productSearchError, setProductSearchError] = useState(null);
  var [productSkusData, setProductSkusData] = useState(null);
  var [productSkusLoading, setProductSkusLoading] = useState(false);
  var [productSkusError, setProductSkusError] = useState(null);
  var [categoriesData, setCategoriesData] = useState(null);
  var [categoriesLoading, setCategoriesLoading] = useState(false);
  var [categoriesError, setCategoriesError] = useState(null);
  var [attributeMetaData, setAttributeMetaData] = useState(null);
  var [attributeMetaDataLoading, setAttributeMetaDataLoading] = useState(false);
  var [attributeMetaDataError, setAttributeMetaDataError] = useState(null);
  var getCustomerGroupCode = () => {
    var _mse$context;
    var globalContext = mse === null || mse === void 0 || (_mse$context = mse.context) === null || _mse$context === void 0 ? void 0 : _mse$context.getContext();
    var {
      customerGroup = {}
    } = globalContext || {};
    return (customerGroup === null || customerGroup === void 0 ? void 0 : customerGroup.customerGroupCode) || DEFAULT_CUSTOMER_GROUP;
  };
  var getRequestIdAndAuthHeaders = () => {
    var _crypto, _mse$context2;
    var searchRequestId = ((_crypto = crypto) === null || _crypto === void 0 ? void 0 : _crypto.randomUUID()) || "";
    var storefrontInstanceContext = mse === null || mse === void 0 || (_mse$context2 = mse.context) === null || _mse$context2 === void 0 ? void 0 : _mse$context2.getStorefrontInstance();
    var customerGroup = getCustomerGroupCode();
    var isDevelopment = process.env.NODE_ENV === 'development';
    var environmentId = isDevelopment ? "83ee3fea-6b33-468f-811a-7e651ceb3020" : storefrontInstanceContext.environmentId;
    return [searchRequestId, {
      "Content-Type": "application/json",
      "Magento-Environment-Id": environmentId,
      "Magento-Store-Code": storefrontInstanceContext.storeCode,
      "Magento-Store-View-Code": storefrontInstanceContext.storeViewCode,
      "Magento-Website-Code": storefrontInstanceContext.websiteCode,
      "Magento-Customer-Group": customerGroup,
      "X-Api-Key": process.env.CATALOG_SERVICE_API_KEY,
      "X-Request-Id": searchRequestId
    }];
  };
  var getProductSearchVariables = args => {
    var customerGroupCode = getCustomerGroupCode();
    return _objectSpread(_objectSpread({}, DEFAULT_PRODUCT_SEARCH_VARIABLES), {}, {
      context: {
        customerGroup: customerGroupCode
      }
    }, args);
  };
  var debouncedProductSearchFetch = useCallback(debounce( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (args) {
      yield directProductSearchFetch(args);
    });
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), debounceTimeout), []);
  var directProductSearchFetch = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (args) {
      try {
        var _productSearch$facets;
        if (!args) {
          return null;
        }
        setProductSearchError(null);
        setProductSearchLoading(true);
        var variables = getProductSearchVariables(args);
        var {
          phrase,
          page_size,
          current_page,
          filter,
          sort,
          context
        } = variables;
        var [searchRequestId, headers] = getRequestIdAndAuthHeaders();
        var queryTypes = ["products"];
        if (includeCategories) {
          queryTypes.push("categories");
        }
        if (includeSuggestions) {
          queryTypes.push("suggestions");
        }
        var newSearchAnalyticsInput = {
          searchUnitId,
          searchRequestId,
          queryTypes,
          phrase,
          pageSize: page_size,
          currentPage: current_page,
          filter,
          sort,
          context
        };
        var searchInput = mse.context.getSearchInput();
        var unitsInput = (searchInput === null || searchInput === void 0 ? void 0 : searchInput.units) || [];
        var unitInputIndex = unitsInput.findIndex(el => el.searchUnitId === searchUnitId);
        if (unitInputIndex >= 0) {
          unitsInput[unitInputIndex] = newSearchAnalyticsInput;
        } else {
          unitsInput.push(newSearchAnalyticsInput);
        }
        var unitsInputContainer = {
          units: unitsInput
        };
        mse.context.setSearchInput(unitsInputContainer);
        mse.publish.searchRequestSent(searchUnitId);
        var response = yield fetch(process.env.CATALOG_SERVICE_DOMAIN, {
          headers,
          method: "POST",
          mode: "cors",
          credentials: "omit",
          body: JSON.stringify({
            query: PRODUCT_SEARCH_QUERY,
            variables
          })
        }).then(res => res.json());
        var {
          data: {
            productSearch
          }
        } = response;
        setProductSearchData(productSearch);
        setProductSearchLoading(false);
        mse.publish.searchResponseReceived(searchUnitId);
        mse.publish.searchResultsView(searchUnitId);

        //because sometimes server returns null for field
        var filteredFacets = (productSearch === null || productSearch === void 0 || (_productSearch$facets = productSearch.facets) === null || _productSearch$facets === void 0 ? void 0 : _productSearch$facets.filter(el => !!el)) || [];
        var categories = [];
        if (includeCategories) {
          var _filteredFacets$find;
          var buckets = (_filteredFacets$find = filteredFacets.find(el => el.attribute === 'categories')) === null || _filteredFacets$find === void 0 || (_filteredFacets$find = _filteredFacets$find.buckets) === null || _filteredFacets$find === void 0 ? void 0 : _filteredFacets$find.filter(el => !!el);
          categories = buckets === null || buckets === void 0 ? void 0 : buckets.map((el, index) => ({
            name: el.name,
            url: el.urlKey,
            rank: index
          }));
        }
        var suggestions = [];
        if (includeSuggestions) {
          var _productSearch$sugges;
          suggestions = productSearch === null || productSearch === void 0 || (_productSearch$sugges = productSearch.suggestions) === null || _productSearch$sugges === void 0 ? void 0 : _productSearch$sugges.map((suggestion, index) => ({
            suggestion,
            rank: index
          }));
        }
        var facets = filteredFacets.filter(el => el.attribute !== 'categories') || [];
        var newSearchAnalyticsResult = {
          searchUnitId,
          searchRequestId,
          categories,
          suggestions,
          products: mapProductToAnalyticTemplate(productSearch),
          page: current_page,
          perPage: page_size,
          facets: facets
        };
        var searchResult = mse.context.getSearchResults();
        var unitsResult = (searchResult === null || searchResult === void 0 ? void 0 : searchResult.units) || [];
        var unitResultIndex = unitsResult.findIndex(el => el.searchUnitId === searchUnitId);
        if (unitResultIndex >= 0) {
          unitsResult[unitResultIndex] = newSearchAnalyticsResult;
        } else {
          unitsResult.push(newSearchAnalyticsResult);
        }
        var unitResultsContainer = {
          units: unitsResult
        };
        mse.context.setSearchResults(unitResultsContainer);
        return productSearch;
      } catch (e) {
        console.error(e);
        setProductSearchError(e);
        sendError(e, ["Product Search"]);
      }
      setProductSearchLoading(false);
      return null;
    });
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [searchUnitId, includeCategories, includeSuggestions]);
  var directProductBySkyFetch = useCallback( /*#__PURE__*/_asyncToGenerator(function* () {
    var skus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    try {
      if (!skus || !skus.length) {
        return null;
      }
      setProductSkusError(null);
      setProductSkusLoading(true);
      var [, headers] = getRequestIdAndAuthHeaders();
      var response = yield fetch(process.env.CATALOG_SERVICE_DOMAIN, {
        headers,
        method: "POST",
        mode: "cors",
        credentials: "omit",
        body: JSON.stringify({
          query: PRODUCT_SKUS_QUERY,
          variables: {
            skus
          }
        })
      }).then(res => res.json());
      var {
        data: {
          products
        }
      } = response;
      setProductSkusData(products);
      setProductSearchLoading(false);
      return products;
    } catch (e) {
      console.error(e);
      setProductSkusError(e);
      sendError(e, ["Product Search By Sku"]);
    }
    setProductSearchLoading(false);
    return null;
  }), []);
  var directCategoriesFetch = useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(function* (variables) {
      if (!variables) {
        return null;
      }
      try {
        setCategoriesError(null);
        setCategoriesLoading(true);
        var [, headers] = getRequestIdAndAuthHeaders();
        var response = yield fetch(process.env.CATALOG_SERVICE_DOMAIN, {
          headers,
          method: "POST",
          mode: "cors",
          credentials: "omit",
          body: JSON.stringify({
            query: CATEGORIES_METADATA_QUERY,
            variables
          })
        }).then(res => res.json());
        var {
          data: {
            categories
          }
        } = response;
        setCategoriesData(categories);
        setCategoriesLoading(false);
        return categories;
      } catch (e) {
        console.error(e);
        setCategoriesError(e);
      }
      setCategoriesLoading(false);
      return null;
    });
    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }(), []);
  var directAttributeMetadataFetch = useCallback( /*#__PURE__*/_asyncToGenerator(function* () {
    try {
      setAttributeMetaDataError(null);
      setAttributeMetaDataLoading(true);
      var [, headers] = getRequestIdAndAuthHeaders();
      var response = yield fetch(process.env.CATALOG_SERVICE_DOMAIN, {
        headers,
        method: "POST",
        mode: "cors",
        credentials: "omit",
        body: JSON.stringify({
          query: ATTRIBUTE_METADATA_QUERY
        })
      }).then(res => res.json());
      var {
        data: {
          attributeMetadata
        }
      } = response;
      setAttributeMetaData(attributeMetadata);
      setAttributeMetaDataLoading(false);
      return attributeMetadata;
    } catch (e) {
      console.error(e);
      setAttributeMetaDataError(e);
    }
    setAttributeMetaDataLoading(false);
    return null;
  }), []);
  var mseCategoryClick = name => {
    mse.publish.searchCategoryClick(searchUnitId, name);
  };
  var mseProductClick = sku => {
    mse.publish.searchProductClick(searchUnitId, sku);
  };
  var mseCategoryResultsView = () => {
    mse.publish.categoryResultsView(searchUnitId);
  };
  var mseSuggestionClick = e => {
    mse.publish.searchSuggestionClick(searchUnitId, e);
  };
  return {
    searchUnitId,
    debouncedProductSearchFetch,
    directProductSearchFetch,
    directProductBySkyFetch,
    directCategoriesFetch,
    directAttributeMetadataFetch,
    productSearchData,
    productSearchLoading,
    productSearchError,
    productSkusData,
    productSkusLoading,
    productSkusError,
    categoriesData,
    categoriesLoading,
    categoriesError,
    attributeMetaData,
    attributeMetaDataLoading,
    attributeMetaDataError,
    mseCategoryClick,
    mseProductClick,
    mseCategoryResultsView,
    mseSuggestionClick
  };
};
export default useStorefrontLiveSearch;